/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */
import React from 'react';
import { css } from '@compiled/react';

import { SimpleTag as Tag } from '@atlaskit/tag';
import TagGroup from '@atlaskit/tag-group';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { QUESTIONS_TOPIC_NATIVE } from '@confluence/named-routes/entry-points/routes.ts';

import { Anchor } from "@atlaskit/primitives/compiled";

const tagLinkStyles = css({
	color: 'inherit',
	':visited': {
		color: 'inherit',
	},
	':hover': {
		color: 'inherit',
	},
	':active': {
		color: 'inherit',
	},
	':focus': {
		color: 'inherit',
	},
});

export type Topic = {
	name: string;
};

type QuestionTopicsProps = {
	topics?: Array<Topic>;
};

export const QuestionTopics: React.FC<QuestionTopicsProps> = ({ topics }) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	if (!topics || topics.length === 0) {
		return null;
	}

	return (
		<TagGroup>
			{topics.map(({ name }) => {
				try {
					const href = QUESTIONS_TOPIC_NATIVE.toUrl({ topicName: name.toLowerCase() });
					return (
						<Tag
							text={name}
							href={href}
							key={name}
							linkComponent={({ children, ...props }) => (
								<Anchor {...props} css={tagLinkStyles}>
									{children}
								</Anchor>
							)}
						/>
					);
				} catch (error) {
					createAnalyticsEvent({
						type: 'sendOperationalEvent',
						data: {
							action: 'failed',
							actionSubject: 'topicUrlGeneration',
							source: 'QuestionTopics',
							attributes: {
								topicName: name,
								errorMessage: error instanceof Error ? error.message : 'Unknown error',
								errorName: error instanceof Error ? error.name : 'Error',
							},
						},
					}).fire();
					return <Tag text={name} key={name} href={undefined} />;
				}
			})}
		</TagGroup>
	);
};
